import z from 'zod'
import { ChannelPreferences, NotificationType } from './notification'

export const UpdateUserSchema = z
    .object({
        firstName: z.string().min(1),
        lastName: z.string().min(1),
        conjunctionalAgencyId: z.string().nullable().optional(),
        salesAgent: z.boolean(),
        salesAssistantConjunctionalAgencyId: z.string().nullable().optional(),
        salesAssistantLeadAgentId: z.string().nullable().optional(),
        emailSignature: z.string().max(500_000, 'Email signature is too large').optional(),
        engagementFee: z.number().min(0).optional(),
    })
    .and(
        z.union([
            z.object({
                superUser: z.literal(false),
                roleId: z.string(),
            }),
            z.object({
                superUser: z.literal(true),
            }),
        ]),
    )

export const AddUserSchema = UpdateUserSchema.and(
    z.object({
        email: z.string().email(),
        mobileNumber: z.string().optional(),
        avatarImage: z.string().max(7_000_000, 'Image must be under 5MB').optional(),
    }),
)

export type AddUserSchema = z.infer<typeof AddUserSchema>
export type UpdateUserSchema = z.infer<typeof UpdateUserSchema>

export interface InternalUserSchema
    extends Omit<
        AddUserSchema,
        | 'profileImage'
        | 'conjunctionalAgencyId'
        | 'roleId'
        | 'superUser'
        | 'salesAgent'
        | 'agencyCommission'
        | 'salesAssistantConjunctionalAgencyId'
        | 'salesAssistantLeadAgentId'
    > {
    userId: string
    firstName: string
    lastName: string
    expoPushTokens?: string[]
    roleId: string
    roleName: string
}

export interface UserTableItemSchema {
    userId: string
    email: string
    mobileNumber: string
    lastLoggedIn: number
    profileImage?: string
    firstName: string
    lastName: string
    notificationPreferences?: Partial<Record<NotificationType, ChannelPreferences>>
}
